import {
	REQUEST_FAVORITES_DATA,
	REQUEST_FAVORITES_DATA_FAILURE,
	REQUEST_FAVORITES_DATA_SUCCESS,
	REQUEST_FAVORITES_META_DATA_SUCCESS,
	REQUEST_SELECTED_FAVORITE_DATA,
	REQUEST_SELECTED_FAVORITE_DATA_FAILURE,
	REQUEST_SELECTED_FAVORITE_DATA_SUCCESS,
} from './favorites.actionTypes';

export const actionCreators = {
	doLoadFavorites: () => ({
		type: REQUEST_FAVORITES_DATA,
	}),
	doLoadFavoritesDataSuccess: (favorites: any) => ({
		type: REQUEST_FAVORITES_DATA_SUCCESS,
		data: favorites,
	}),
	doLoadFavoritesDataError: (error: any) => ({
		type: REQUEST_FAVORITES_DATA_FAILURE,
		error,
	}),
	doLoadFavoritesMetaDataSuccess: (favoritesIds) => ({
		type: REQUEST_FAVORITES_META_DATA_SUCCESS,
		data: favoritesIds,
	}),
	doLoadSelectedFavoriteData: (id: string, contentType: string) => ({
		type: REQUEST_SELECTED_FAVORITE_DATA,
		contentType,
		id,
	}),
	doLoadSelectedFavoriteDataSuccess: (item: any) => ({
		type: REQUEST_SELECTED_FAVORITE_DATA_SUCCESS,
		item,
	}),
	doLoadSelectedFavoriteDataError: (error: any) => ({
		type: REQUEST_SELECTED_FAVORITE_DATA_FAILURE,
		error,
	}),
};

export type FavoritesActionType =
	| ReturnType<typeof actionCreators.doLoadFavorites>
	| ReturnType<typeof actionCreators.doLoadFavoritesDataSuccess>
	| ReturnType<typeof actionCreators.doLoadFavoritesDataError>
	| ReturnType<typeof actionCreators.doLoadFavoritesMetaDataSuccess>
	| ReturnType<typeof actionCreators.doLoadSelectedFavoriteData>
	| ReturnType<typeof actionCreators.doLoadSelectedFavoriteDataSuccess>
	| ReturnType<typeof actionCreators.doLoadSelectedFavoriteDataError>;
